// InstructionListPage.tsx
import React, { useEffect, useState } from "react";
import {
  Grid,
  Segment,
  Loader,
  Message,
  Container,
  Header,
  Icon,
  Button,
} from "semantic-ui-react";
import LocalStorage from "../../../lib/LocalStorage";
import config from "../../../common/repository/config";
import { useHistory } from 'react-router-dom';
interface Instruction {
  _id: string;
  title: string;
  type_id:string
  metadata: {
    claimNumber: string;
    instruction: string;
  
    postedOn: string;
  };
}

interface InstructionResponse {
  success: boolean;
  message: string | null;
  data: {
    total_item_count: number;
    items: Instruction[];
  };
}

const InstructionListPage: React.FC = () => {
  const [instructions, setInstructions] = useState<Instruction[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const history = useHistory();
  useEffect(() => {
    const fetchInstructionList = async () => {
      setLoading(true);
      try {
        const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
        if (!token) return;

        const response = await fetch(
          `${config.apiBaseURL}/notification/countInstruction`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-access-token": token,
            },
            body: JSON.stringify({ count: false }),
          }
        );

        if (!response.ok) throw new Error("Failed to fetch instructions");

        const data: InstructionResponse = await response.json();
        setInstructions(data.data.items || []);
    } catch (err) {
        const errorMessage =
          err instanceof Error ? err.message : "Something went wrong";
        setError(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    fetchInstructionList();
  }, []);

  const openCase = (caseId: string) => {
    console.log(caseId)
    history.push(`/case/view/${caseId}`);
  };

  return (
    <Container style={{ marginTop: "2rem" }}>
      <Header as="h2" dividing>
        <Icon name="clipboard list" />
        <Header.Content>Instruction List</Header.Content>
      </Header>

      {loading && <Loader active inline="centered" />}
      {error && <Message negative>{error}</Message>}
      {!loading && instructions.length === 0 && (
        <Message info icon>
          <Icon name="info circle" />
          <Message.Content>No instructions found</Message.Content>
        </Message>
      )}

      <Grid stackable columns={2} doubling>
        {instructions.map((item) => (
        <Grid.Column key={item._id}>
        <Segment 
          raised 
          padded="very" 
          onClick={() => openCase(item.type_id)} 
          style={{ cursor: "pointer" }}
        >
          <Header as="h4" color="blue" dividing>
            <Icon name="tasks" />
            <Header.Content>{item.title}</Header.Content>
          </Header>
      
          <p>
            <strong>📌 Claim:</strong> {item.metadata.claimNumber}
          </p>
          <p>
            <strong>📝 Instruction:</strong> {item.metadata.instruction}
          </p>
          <p>
            <strong>📅 Posted On:</strong> {item.metadata.postedOn}
          </p>
        </Segment>
      </Grid.Column>
      
        ))}
      </Grid>
    </Container>
  );
};

export default InstructionListPage;
